module.exports = __webpack_public_path__ + "img/aiti.a583ebde.png";